var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Copyright"},[_vm._v("\n    版权声明：本数据仅可免费用于学术用途和其他非商业用途。未经事先许可，不得重新发行或用于商业用途。使用本产品的用户应明确标明来源及作者。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }